module.exports = __webpack_public_path__ + "static/media/planning.4f5dc1ff.svg";